import { render, staticRenderFns } from "./IconNew.vue?vue&type=template&id=43b25017&scoped=true&"
import script from "./IconNew.vue?vue&type=script&lang=js&"
export * from "./IconNew.vue?vue&type=script&lang=js&"
import style0 from "./IconNew.vue?vue&type=style&index=0&id=43b25017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b25017",
  null
  
)

export default component.exports